import { Link, Text, VStack } from "@chakra-ui/react";
import React from "react";

const WHATSAPP_PHONE = "201120099900";

const PoweredByAsquera = ({ color = "inherit", align = "flex-start" }) => {
  const textAlign =
    align === "center" ? "center" : align === "flex-end" ? "right" : "left";

  return (
    <VStack align={align} spacing={0}>
      <Text fontSize="sm" fontWeight="600" color={color}>
        Powered by
      </Text>
      <Link
        href={`https://wa.me/${WHATSAPP_PHONE}`}
        isExternal
        aria-label="Chat on WhatsApp with Asquera Systems Educational Excellence"
        textAlign={textAlign}
        _hover={{ opacity: 0.8, textDecoration: "none" }}
      >
        <Text fontSize="sm" fontWeight="800" color={color} lineHeight="short">
          Asquera Systems
        </Text>
        <Text fontSize="sm" fontWeight="800" color={color} lineHeight="short">
          Educational Excellence
        </Text>
      </Link>
    </VStack>
  );
};

export default PoweredByAsquera;
